import { Card, CardHeader, Divider, Typography } from "@mui/material";
import { MetricsCollectionFilterButton, TeamMetricsGrid } from "src/components";
import { useMeetingSettings } from "../hooks";
import { useGetTeam } from "src/http";

interface IProps {
  meetingGuid: string;
  teamSlug: string;
}

const TeamMetricsReview = (props: IProps) => {
  const { settings, updateSettings } = useMeetingSettings(props.meetingGuid);
  const { data: team, isLoading: isLoadingTeam } = useGetTeam(props.teamSlug);

  if (!isLoadingTeam && team && team.metricCollectionGuid !== null) {
    return (
      <Card>
        <CardHeader
          title={<Typography variant="h6">Metrics Review</Typography>}
          action={
            <MetricsCollectionFilterButton
              variant="icon"
              metricCollectionGuid={team.metricCollectionGuid}
              filterByOption={settings.filterByOption}
              filterByValue={settings.filterByValue}
              onFilterChanged={(filterByOption, filterByValue) => updateSettings({ filterByOption, filterByValue })}
            />
          }
        />
        <Divider />

        <TeamMetricsGrid team={team} filterByOption={settings.filterByOption} filterByValue={settings.filterByValue} />
      </Card>
    );
  }

  return null;
};

export { TeamMetricsReview };
